export default "__VITE_ASSET__D_IGUK0U__"